export const formValidationMixin = {
  data() {
    return {
      reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      errors: {
        name: null,
        email: null,
        password: null,
        password_confirmation: null,
      },
    };
  },
  methods: {
    clearErrors() {
      this.errors = {
        name: null,
        email: null,
        password: null,
        password_confirmation: null,
      };
    },

    isEmail: function (email) {
      return email == '' ? '' : this.reg.test(email) ? true : false;
    },

    showError(field, msg) {
      this.errors[field] = [msg];
    },

    isValidName() {
      if (this.form.name && this.form.name.length > 2) {
        return true;
      }
      this.showError('name', this.$t('warnings.invalidName'));
      return false;
    },

    isValidEmail() {
      if (!this.isEmail(this.form.email)) {
        this.showError('email', this.$t('warnings.invalidEmail'));
        return false;
      }
      return true;
    },

    isValidEmailField() {
      if (!this.isEmail(this.email)) {
        this.showError('email', this.$t('warnings.invalidEmail'));
        return false;
      }
      return true;
    },

    isValidUserName(defaultName) {
      if(this.name != defaultName) {
        return true;
      }
      this.showError('name', this.$t('warnings.invalidName'));
      return false;
    },

    isValidPassword() {
      return this.validatePassword(this.form.password, 'password');
    },

    validatePassword(password, fieldName = 'newPassword') {
      if (password && password.length >= 8) {
        return true;
      }
      this.showError(fieldName, this.$t('warnings.passwordRule'));
      return false;
    },

    isValidPasswordConfirmation() {
      if (this.form.password === this.form.password_confirmation) {
        return true;
      }
      this.showError(
        'password',
        this.$t('warnings.invalidPasswordConfirmation')
      );
      return false;
    },
    translatesBackendErrors(error) {
      if (error.response.status === 422) {
        //this.errors = error.response.data.errors;
        const errors = error.response.data.errors;
        this.errors = {};
        for (const key in errors) {
          const messages = errors[key];
          console.log(`${key}:`, messages);
          this.errors[key] = [];
          messages.forEach((msg) => {
            console.log(msg);
            //this.errors[key].push( this.$t('errors.error1'));
            this.errors[key].push(this.$t(msg));
          });
        }
      }
    },
  },
};
